import { productShareLinkStyles as styles } from "@insite/content-library/Components/ProductShareLink";
import Share from "@insite/mobius/Icons/Share";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.link = {
    ...styles.link,
    icon: {
        ...styles.link?.icon,
        iconProps: {
            src: Share,
            size: 12,
            color: colorStrings.primaryMain,
        },
        position: "left",
    },
    typographyProps: {
        ...styles.link?.typographyProps,
        css: css`
            ${styles.link?.typographyProps?.css};
            font-size: 10px;
            ${mediaQueriesBP.minMD} {
                font-size: 12px;
            }
        `,
    },
    css: css`
        ${styles.link?.css};
        min-height: 30px;
    `,
};
